import { Ring } from "@biggeo/bg-server-lib/studio";

export const levelSetPercentiles = [0.0, 20.0, 40.0, 60.0, 80.0];

export const defaultLevelSets: {
    percentile: number;
    rings: Ring[];
}[] = [
    { percentile: 0.0, rings: [] },
    { percentile: 20.0, rings: [] },
    { percentile: 40.0, rings: [] },
    { percentile: 60.0, rings: [] },
    { percentile: 80.0, rings: [] },
];

export const collectionStorageDirectory = "/storage";